import React from 'react';
import Slider from 'slider';
import _FavoriteCategoryContainer from './_FavoriteCategoryContainer.scss';
import {Link} from 'react-router-dom';
import {Categories} from 'api';
import {withRouter} from 'react-router-dom';

class FavoriteCategoryContainer extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [],
      limit: 10
    }
  }

  componentDidMount() {
    let params = {
      filter: {
        limit: this.state.limit,
        where: {
          isFavorite: true
        }
      }
    };
    Categories.actions.list.request(params).then(response => {
      this.setState({
        data: response.data
      });
    });
  }

  render() {
    const settings = {
      className: 'slider variable-width favorite-slick',
      dots: false,
      infinite: false,
      centerMode: false,
      slidesToShow: 5,
      slidesToScroll: 1,
      responsive: [{
        breakpoint: 1201,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 651,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 551,
        settings: {
          slidesToShow: 1
        }
      }]
    };
    return (
      <section className='center'>
        <div className='favorite-category-container'>
          <div className='favorite-left-content'>
            <p className='favorite-iton'>
              <i className='vtd vtd-star'></i>
            </p>
            <p className='title-black'>{this.props.blackTitle}</p>
            <p className='title-red'>{this.props.redTitle}</p>
          </div>
          <div className='favorite-right-content'>
            <Slider {...settings}>
              {
                this.state.data.map((item, i) => {
                  return(
                    <div className='favorite-item'>
                        <span className='wrap-image'>
                          <Link className='item-link' to={`list-products/${item.id}`}>
                            <i className={`favorite-image ${item.largeIcon}`}/>
                          </Link>
                        </span>
                        <Link className='favorite-name' to={`categories/${item.id}`}>{item.name}</Link>
                    </div>
                  )
                })
              }
            </Slider>
          </div>
        </div>
      </section>
    );
  }
}

FavoriteCategoryContainer.defaultProps = {
  blackTitle: 'Nhóm sản phẩm',
  redTitle: 'Được ưu thích'
}

export default withRouter(FavoriteCategoryContainer);



// WEBPACK FOOTER //
// ./components/home/sub-view/FavoriteCategoryContainer.jsx